module.exports = __webpack_public_path__ + "static/media/arrow-up.98cb1bef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/arrow-up.svg
// module id = 121
// module chunks = 0